export const transTypes = [
    { transType: '4210', label: '借款' },
    { transType: '4220', label: '現金還款' },
    { transType: '4260', label: '繳付保品' },
    { transType: '4270', label: '賣出還款' },
    { transType: '4290', label: '退還保品' },
];
